module.exports = __webpack_public_path__ + "img/q_img08.92d212b7.jpg";